import React from "react";
import logoImg from "../static/images/applogo.jpg";

export default function CustomLogoLoader({ size }) {
  // Direct fail-proof dimensions for a beautiful, compact centered logo spinner
  const isSmall = size === "small";
  const wrapperSize = isSmall ? 48 : 80;
  const outerRingSize = isSmall ? 40 : 70;
  const logoWidth = isSmall ? 26 : 46;
  const logoHeight = isSmall ? 26 : 46;

  return (
    <div 
      className="custom-loader-wrapper" 
      style={{ 
        width: wrapperSize, 
        height: wrapperSize,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        margin: "0 auto"
      }}
    >
      <div 
        className="custom-loader-ring" 
        style={{ 
          width: outerRingSize, 
          height: outerRingSize,
          boxSizing: "border-box",
          position: "absolute"
        }} 
      />
      {!isSmall && (
        <div 
          className="custom-loader-ring-inner" 
          style={{ 
            width: 56, 
            height: 56,
            boxSizing: "border-box",
            position: "absolute"
          }} 
        />
      )}
      <img
        src={logoImg}
        alt="Loading..."
        className="custom-loader-logo"
        style={{
          width: logoWidth,
          height: logoHeight,
          objectFit: "cover",
          borderRadius: "50%",
          position: "absolute",
          zIndex: 2
        }}
      />
    </div>
  );
}
